import { MemoryApiCredentials } from '@inspace-org/client';

export const apiCredentials = new MemoryApiCredentials();
